import { DialogPreRenderDemo } from '@/components/examples/DialogPreRenderExample';

export default function TestDialogPage() {
	return (
		<div className="container mx-auto py-8">
			<DialogPreRenderDemo />
		</div>
	);
}
